const log = {
  logsBelong: '日志归属',
  recorder: '记录者',
  logType: '类型',
  loginType: '登录方式',
  content: '内容',
  export: '导出',
  details: '详情',
}
export default log